import { render } from "./_Index.vue?vue&type=template&id=99778902&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=99778902&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-99778902"

export default script